import Column from '@components/Column';
import styled from '@emotion/styled';
import { UserCouponResponse } from '@models/coupon';

import CouponImageCard from './CouponImageCard';
import CouponText from './CouponText';

interface Props {
    coupon: UserCouponResponse;
}

function CouponInfo({ coupon }:Props) {
    return (
        <Container align='center' >
            <CouponImageCard coupon={coupon}/>
            <CouponText coupon={coupon} />
        </Container>
    );
}

const Container = styled(Column)`
    border-bottom: 4px dashed var(--color-gray3);
    margin: 0 20px;
    padding: 28px 0 14px;
    width: calc(100% - 40px) !important;
`;

export default CouponInfo;
